import { useEffect } from 'react';

function useOnClickOutside(ref, onClickOutside, disabled) {
    useEffect(() => {
        function handleClickOutside(event) {
            const { current } = ref;
            if (current && !current.contains(event.target)) {
                // prevent double event triggering on touch devices.
                event.preventDefault();
                onClickOutside();
            }
        }
        if (!disabled) {
            document.body.addEventListener('mousedown', handleClickOutside, { capture: true });
            // { passive: false } because:
            // "React adds event listeners as passive (the new default) and passive event listeners do not allow calling preventDefault."
            // https://github.com/facebook/react/issues/9809
            document.body.addEventListener('touchstart', handleClickOutside, { passive: false, capture: true });
        }
        return () => {
            if (!disabled) {
                document.body.removeEventListener('mousedown', handleClickOutside, { capture: true });
                document.body.removeEventListener('touchstart', handleClickOutside, { capture: true });
            }
        };
    }, [ref, onClickOutside, disabled]);
}

export { useOnClickOutside };
